import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderAddLeft: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="folder-add-left">
      <path
        d="M3 10V4H10L12 7H21V19H12M5 14V17M5 17V20M5 17H2M5 17H8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconFolderAddLeft;
